export interface FeedItem {
  id: number;
  title: string;
  category: string;
  categoryTag: string;
  heat: number;
  time: string;
  source: string;
  sourceHandle: string;
  excerpt: string;
  trending: boolean;
}

export interface Blogger {
  id: number;
  handle: string;
  display: string;
  category: string;
  verified: string;
  followers: string;
  intro: string;
  icon: string;
  hot: boolean;
}

export const categories = [
  { key: 'all', label: '全部' },
  { key: 'ent', label: '文娱八卦' },
  { key: 'celeb', label: '明星艺人' },
  { key: 'brand', label: '品牌商业' },
  { key: 'tech', label: '科技数码' },
  { key: 'sports', label: '体娱赛场' },
  { key: 'life', label: '生活方式' },
];

export const domainTags = [
  { label: '文娱八卦', desc: '综艺热点与圈内动向', icon: 'ri-vip-crown-line' },
  { label: '明星艺人', desc: '艺人动态与作品资讯', icon: 'ri-star-smile-line' },
  { label: '品牌商业', desc: '品牌动向与商业观察', icon: 'ri-store-3-line' },
  { label: '科技数码', desc: '科技圈与大厂动态', icon: 'ri-computer-line' },
  { label: '体娱赛场', desc: '赛事与运动员动向', icon: 'ri-trophy-line' },
  { label: '生活方式', desc: '时尚潮流与生活热梗', icon: 'ri-cup-line' },
];

export const hotRank = [
  { rank: 1, title: '知名综艺被曝节目组调整常驻阵容，老粉纷纷下场讨论', heat: 982, tag: '热', field: '文娱八卦' },
  { rank: 2, title: '某品牌代言人更替引发粉丝不满，评论区两级分化', heat: 921, tag: '沸', field: '品牌商业' },
  { rank: 3, title: '顶流艺人海外行程曝光，被拍到与团队现身机场', heat: 874, tag: '热', field: '明星艺人' },
  { rank: 4, title: '科技博主爆料头部厂商新机供应链细节，坐等官宣', heat: 812, tag: '热', field: '科技数码' },
  { rank: 5, title: '体娱圈名场面回放刷屏，网友称年度最佳', heat: 766, tag: '新', field: '体娱赛场' },
  { rank: 6, title: '时尚界新联名预告流出，粉丝已经准备冲首波', heat: 705, tag: '新', field: '生活方式' },
  { rank: 7, title: '某选秀回锅选手回归引热议，票数走势成焦点', heat: 648, tag: '新', field: '文娱八卦' },
  { rank: 8, title: '短视频平台博主集体晒同款，引发全网模仿热潮', heat: 593, tag: '新', field: '生活方式' },
  { rank: 9, title: '影视项目选角消息疯传，制作方回应仍在洽谈', heat: 537, tag: '新', field: '明星艺人' },
  { rank: 10, title: '行业沙龙现场爆料某品牌渠道新政，商家各持己见', heat: 489, tag: '新', field: '品牌商业' },
];

export const feedItems: FeedItem[] = [
  {
    id: 1, title: '综艺常驻阵容生变引热议，导演组回应称是正常更替', category: 'ent',
    categoryTag: '文娱八卦', heat: 982, time: '8 分钟前', source: '圈内速递', sourceHandle: '@娱乐风向标', trending: true,
    excerpt: '有知情博主发文称某热门综艺下一季常驻阵容将大幅调整，随后引发大量老观众讨论。制作方回应称属正常节目更替，具体名单以官宣为准。',
  },
  {
    id: 2, title: '顶流艺人低调回国行程被拍，粉丝机场应援秩序引讨论', category: 'celeb',
    categoryTag: '明星艺人', heat: 921, time: '18 分钟前', source: '前线直击', sourceHandle: '@镜头捕捉站', trending: true,
    excerpt: '某人气艺人结束海外行程低调返程，被现场网友拍到现身。工作室随后发文感谢粉丝接机，同时提醒注意出行安全与秩序。',
  },
  {
    id: 3, title: '科技圈爆料：头部厂商折叠屏新机参数再流出，真假待定', category: 'tech',
    categoryTag: '科技数码', heat: 812, time: '32 分钟前', source: '数码前线', sourceHandle: '@搞机情报局', trending: true,
    excerpt: '有博主晒出疑似新机供应链参数，称机身更轻薄、铰链升级明显。不过爆料源称仍需以厂商最终发布会信息为准，请理性看待。',
  },
  {
    id: 4, title: '品牌代言人更替引粉丝不满，品牌方强调合作属正常商业决策', category: 'brand',
    categoryTag: '品牌商业', heat: 788, time: '45 分钟前', source: '商业内参', sourceHandle: '@商界瞭望', trending: false,
    excerpt: '某消费品牌更换代言人后，社交平台评论区出现两极反应。品牌方回应称代言更替是正常商业行为，将一如既往重视用户反馈。',
  },
  {
    id: 5, title: '年度体娱名场面回放冲上热榜，裁判判罚成最大争议点', category: 'sports',
    categoryTag: '体娱赛场', heat: 766, time: '1 小时前', source: '赛场观察', sourceHandle: '@体坛速递员', trending: true,
    excerpt: '一场关键对决的高光回放在各大平台刷屏，其中一次争议判罚成为讨论核心。评论员与网友各执一词，相关话题持续升温。',
  },
  {
    id: 6, title: '生活方式博主带火“松弛感穿搭”，全网刮起休闲风', category: 'life',
    categoryTag: '生活方式', heat: 705, time: '2 小时前', source: '生活分享', sourceHandle: '@质感生活家', trending: false,
    excerpt: '多位穿搭博主近期集中分享“松弛感”主题，宽松剪裁与舒适面料成为新宠。不少网友表示已默默收藏同款清单。',
  },
  {
    id: 7, title: '回锅选手高调回归，选秀票数走势引发粉丝团battle', category: 'ent',
    categoryTag: '文娱八卦', heat: 648, time: '3 小时前', source: '选秀前线', sourceHandle: '@舞台追踪', trending: false,
    excerpt: '曾参加多档节目的人气选手宣布回归，社交平台瞬间被刷屏。粉丝团为助力票数开启“冲刺”，讨论热度居高不下。',
  },
  {
    id: 8, title: '大厂被曝年度发布会提前，折叠屏与AI眼镜同台？', category: 'tech',
    categoryTag: '科技数码', heat: 612, time: '4 小时前', source: '科技快讯', sourceHandle: '@数字脉搏', trending: false,
    excerpt: '有业内人士爆料某科技大厂或提前举办年度发布会，届时有望同台亮相新一代折叠屏与AI智能眼镜。官方暂未置评。',
  },
  {
    id: 9, title: '影视项目选角风声四起，片方称“目前均为市场传闻”', category: 'celeb',
    categoryTag: '明星艺人', heat: 573, time: '5 小时前', source: '剧组情报', sourceHandle: '@影视那些事', trending: false,
    excerpt: '某待拍大IP被曝接触多位当红演员，选角猜测刷屏。片方回应称项目确实筹备中，但具体阵容尚未确定，请勿轻信传言。',
  },
  {
    id: 10, title: '短视频同款挑战爆火，网友从穿搭玩到了美食与手工', category: 'life',
    categoryTag: '生活方式', heat: 537, time: '6 小时前', source: '生活发现', sourceHandle: '@发现新玩法', trending: false,
    excerpt: '一条“沉浸式做某物”的视频引发全网模仿，博主们纷纷加入挑战，衍生出穿搭、美食与手工等多个版本。',
  },
];

export const bloggers: Blogger[] = [
  {
    id: 1, handle: '@娱乐风向标', display: '娱乐风向标', category: 'ent', verified: '明星经纪人博主',
    followers: '1286 万', icon: 'ri-vip-crown-line', hot: true,
    intro: '深耕文娱圈多年，专注综艺内幕与艺人动向的及时梳理，敢于抛出争议话题并理性引导讨论。',
  },
  {
    id: 2, handle: '@镜头捕捉站', display: '镜头捕捉站', category: 'celeb', verified: '一线时尚媒体人',
    followers: '937 万', icon: 'ri-camera-3-line', hot: true,
    intro: '专注一线行程与红毯现场，第一时间呈现艺人真实动态，注重还原现场而不做无根据猜测。',
  },
  {
    id: 3, handle: '@搞机情报局', display: '搞机情报局', category: 'tech', verified: '数码评测博主',
    followers: '768 万', icon: 'ri-phone-line', hot: false,
    intro: '数码圈知名爆料源，长期跟踪新机供应链与系统更新，习惯标注信息来源，供大家理性判断。',
  },
  {
    id: 4, handle: '@商界瞭望', display: '商界瞭望', category: 'brand', verified: '资深财经评论人',
    followers: '521 万', icon: 'ri-line-chart-line', hot: false,
    intro: '用通俗语言拆解品牌策略与商业现象，从渠道政策到代言合作，提供反直觉但值得参考的观察。',
  },
  {
    id: 5, handle: '@体坛速递员', display: '体坛速递员', category: 'sports', verified: '体育资深编辑',
    followers: '486 万', icon: 'ri-football-line', hot: false,
    intro: '覆盖足篮网球与各类赛事，赛前爆料与赛后复盘两手抓，语言犀利又不失专业度。',
  },
  {
    id: 6, handle: '@质感生活家', display: '质感生活家', category: 'life', verified: '生活美学达人',
    followers: '634 万', icon: 'ri-handbag-line', hot: true,
    intro: '专注生活方式与潮流趋势，从穿搭美学到生活热梗，擅于把零散热点串联成完整脉络。',
  },
];

export const briefingTimeline = [
  { time: '14:20', text: '某综艺录制地路透流出，现场安保升级引猜测。' },
  { time: '13:45', text: '头部厂商新机海报内部流出，供应链人士证实相关配色。' },
  { time: '12:10', text: '某体娱选手赛后采访金句刷屏，登上多平台热搜。' },
  { time: '11:32', text: '生活方式类“沉浸式”挑战衍生出第三波模仿。' },
  { time: '10:58', text: '品牌方深夜官宣新代言人，营销界开始拆解campaign。' },
  { time: '10:20', text: '影视项目疑似洽谈顶流，豆瓣词条访问量激增。' },
];

export interface Special {
  id: number;
  tag: string;
  title: string;
  summary: string;
  image: string;
  wordCount: string;
  readTime: string;
}

export const specials: Special[] = [
  {
    id: 1, tag: '文娱观察', title: '当综艺“改阵容”登上热搜：观众情绪为何比正片还精彩',
    summary: '一档国民综艺因常驻阵容调整引发连续讨论，这背后既有节目方的商业考量，也有观众多年陪伴的投入。本文尝试拆解热榜事件的来龙去脉。',
    wordCount: '约 3200 字', readTime: '阅读 6 分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20microphone%20and%20backstage%20lights%20on%20warm%20cream%20background%2C%20cinematic%20mood%2C%20soft%20dramatic%20shadow%2C%20premium%20magazine%20style&width=1200&height=800&seq=special-ent-2026&orientation=landscape',
  },
  {
    id: 2, tag: '科技拆解', title: '从供应链流出的新机参数，可信度到底有几分？',
    summary: '每逢新品发布季，折叠屏与AI硬件的爆料总在官宣前先行一步。哪些细节经得起推敲，哪些只是捕风捉影？我们聊聊爆料信息的验证方法论。',
    wordCount: '约 2800 字', readTime: '阅读 5 分钟',
    image: 'https://readdy.ai/api/search-image?query=minimalist%20product%20rendering%20of%20foldable%20smartphone%20on%20warm%20neutral%20desk%2C%20soft%20natural%20light%2C%20editorial%20tech%20photography%2C%20calm%20premium%20tone&width=1200&height=800&seq=special-tech-2026&orientation=landscape',
  },
  {
    id: 3, tag: '商业观察', title: '代言人换人之后：品牌如何接住粉丝的情绪与流量',
    summary: '一次代言更替，评论区可以瞬间成为“战场”。对品牌而言，如何平衡商业决策与用户情感，是每次更替都必须面对的考题。',
    wordCount: '约 2500 字', readTime: '阅读 5 分钟',
    image: 'https://readdy.ai/api/search-image?query=abstract%20business%20concept%20with%20contract%20and%20signature%20pen%20on%20paper%20texture%2C%20warm%20amber%20light%2C%20editorial%20finance%20photography%2C%20refined%20minimal%20composition&width=1200&height=800&seq=special-brand-2026&orientation=landscape',
  },
];

export const faqs = [
  {
    q: '这个平台的内容来源是什么？',
    a: '我们主要聚合公开社交平台上认证博主、红人与领域作者公开发布的信息与讨论，仅做二次整理与索引，帮助大家更高效地定位一手信息来源。',
  },
  {
    q: '平台上能看到“实锤”吗？',
    a: '本平台定位是信息聚合与来源推荐，不自行认定“实锤”。所有内容以博主公开言论为依据，事件真实性请以当事方官宣与权威信息为准。',
  },
  {
    q: '如何挑选靠谱的爆料账号？',
    a: '建议优先关注认证信息完整、长期输出垂直内容、习惯标注信息来源的博主。我们也会结合账号内容质量、更新频率与社区反馈进行推荐。',
  },
  {
    q: '发现转载内容有误或侵权怎么办？',
    a: '如果你认为某条聚合内容存在事实错误或涉及版权问题，可通过页脚联系方式反馈，我们核实后将第一时间处理或标注澄清。',
  },
  {
    q: '我可以申请把自己的账号收录进来吗？',
    a: '欢迎垂直领域、持续输出原创内容的认证博主联系我们提交收录申请，通过内容审核后会纳入对应分类推荐列表。',
  },
];